import React from "react";
import Chart from "react-apexcharts";
import { COLOR_VALOR_INVENTARIO } from "./constants";
import { formatCurrency, formatEjeMonto } from "./utils";

export default function GraficoValorInventario(props) {
    const moneda = props.moneda || "PEN";

    const options = {
        chart: {
            type: "area",
            toolbar: { show: false },
            zoom: { enabled: false },
        },
        colors: [COLOR_VALOR_INVENTARIO],
        stroke: { width: 2, curve: "straight" },
        markers: { size: 3, strokeWidth: 0, hover: { size: 5 } },
        fill: {
            type: "gradient",
            gradient: { shadeIntensity: 1, opacityFrom: 0.25, opacityTo: 0.05, stops: [0, 100] },
        },
        dataLabels: { enabled: false },
        xaxis: {
            categories: props.timeLine || [],
            // Con un mes completo hay ~30 etiquetas; se dejan pocas para que
            // no se encimen (el tooltip muestra el dia exacto).
            tickAmount: 12,
            labels: { rotate: 0, hideOverlappingLabels: true },
            axisBorder: { show: false },
            axisTicks: { show: false },
        },
        yaxis: {
            min: 0,
            forceNiceScale: true,
            labels: { formatter: formatEjeMonto },
        },
        grid: { borderColor: "#eef0f2", strokeDashArray: 3 },
        tooltip: {
            y: { formatter: (val) => formatCurrency(val, moneda) },
        },
        legend: { show: false },
    };

    // react-apexcharts compara las options con JSON.stringify (ignora las
    // funciones): sin la key, el tooltip seguiria en la moneda anterior.
    return (
        <Chart
            key={moneda}
            options={options}
            series={[{ name: "Valor de Inventario", data: props.serie || [] }]}
            type="area"
            height={250}
        />
    );
}
